module.exports = __webpack_public_path__ + "img/ico11.d7cf7d9d.svg";